// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/information/information.scss
 ** module id = 155
 ** module chunks = 0 1
 **/